module.exports = __webpack_public_path__ + "static/media/yash_shah.97156f25.png";